// Mock data for HowzTech website

export const services = [
  {
    id: 1,
    title: "Web Design & Development",
    description: "Custom websites and web applications built with cutting-edge technologies for optimal performance and user experience.",
    icon: "web",
    features: ["Responsive Design", "Progressive Web Apps", "E-commerce Solutions"]
  },
  {
    id: 2,
    title: "Software & ERP Solutions",
    description: "Enterprise-grade software solutions tailored to streamline your business operations and boost productivity.",
    icon: "software",
    features: ["Custom ERP Systems", "CRM Solutions", "Business Automation"]
  },
  {
    id: 3,
    title: "Mobile App Development",
    description: "Native and cross-platform mobile applications that deliver exceptional user experiences on iOS and Android.",
    icon: "mobile",
    features: ["iOS Development", "Android Development", "React Native"]
  },
  {
    id: 4,
    title: "AI & Automation",
    description: "Intelligent automation solutions powered by artificial intelligence to transform your business processes.",
    icon: "ai",
    features: ["Machine Learning", "Process Automation", "AI Chatbots"]
  },
  {
    id: 5,
    title: "Branding & UI/UX",
    description: "Create compelling brand identities and intuitive user experiences that resonate with your target audience.",
    icon: "design",
    features: ["Brand Strategy", "UI Design", "UX Research"]
  },
  {
    id: 6,
    title: "Cloud Solutions",
    description: "Scalable cloud infrastructure and migration services to ensure your business stays agile and secure.",
    icon: "cloud",
    features: ["Cloud Migration", "DevOps", "Infrastructure Management"]
  }
];

export const stats = [
  { label: "Projects Completed", value: 50, suffix: "+" },
  { label: "Happy Clients", value: 50, suffix: "+" },
  { label: "Team Members", value: 20, suffix: "+" },
  { label: "Years Experience", value: 4, suffix: "+" }
];

// export const projects = [
//   {
//     id: 1,
//     title: "Enterprise Analytics Platform",
//     category: "Web Development",
//     description: "Real-time data visualization dashboard for enterprise clients",
//     image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f",
//     tags: ["React", "Django", "Python"]
//   },
//   {
//     id: 2,
//     title: "E-Commerce Mobile App",
//     category: "Mobile Development",
//     description: "Feature-rich shopping app with AI-powered recommendations",
//     image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085",
//     tags: ["React Native", "AI/ML", "Firebase"]
//   },
//   {
//     id: 3,
//     title: "AI-Powered CRM System",
//     category: "AI & Automation",
//     description: "Intelligent customer relationship management with predictive analytics",
//     image: "https://images.unsplash.com/photo-1675557570482-df9926f61d86",
//     tags: ["Python", "TensorFlow", "PostgreSQL"]
//   },
//   {
//     id: 4,
//     title: "Healthcare Management System",
//     category: "Software Development",
//     description: "Comprehensive ERP solution for healthcare providers",
//     image: "https://images.pexels.com/photos/1972464/pexels-photo-1972464.jpeg",
//     tags: ["Django", "Vue.js", "MySQL"]
//   },
//   {
//     id: 5,
//     title: "Fintech Mobile Platform",
//     category: "Mobile Development",
//     description: "Secure banking and investment application",
//     image: "https://images.pexels.com/photos/4164418/pexels-photo-4164418.jpeg",
//     tags: ["Flutter", "Blockchain", "AWS"]
//   },
//   {
//     id: 6,
//     title: "Marketing Automation Suite",
//     category: "AI & Automation",
//     description: "AI-driven marketing automation and analytics platform",
//     image: "https://images.unsplash.com/photo-1720962158937-7ea890052166",
//     tags: ["React", "Python", "OpenAI"]
//   }
// ];

export const projects = [
  {
    id: 1,
    title: "Lineage Document Verification System",
    category: "Web Development",
    description: "Secure digital system verifying lineage documents through serial-based authentication online",
    image: "project images/Lineage Document Verification System.jpeg",
    tags: ["React", "Django", "Python"],
    link: "http://the-hashemites-lineages.vercel.app/"
  },
  {
    id: 2,
    title: "LuxeCraft – Timeless Furniture Experience",
    category: "Mobile Development",
    description: "Luxury furniture website showcasing timeless design, craftsmanship, elegant user experience",
    image: "project images/LuxeCraft – Timeless Furniture Experience.jpeg",
    tags: ["React Native", "AI/ML", "Firebase"],
    link: "https://luxe-example-howztech.vercel.app/"
  },
  {
    id: 3,
    title: "Premium Hajj & Umrah Travel Website",
    category: "AI & Automation",
    description: "Premium Hajj Umrah website offering packages, visa assistance, pilgrimage services",
    image: "project images/Premium Hajj & Umrah Travel Website.jpeg",
    tags: ["Python", "TensorFlow", "PostgreSQL"],
    link:"https://travels-example-howztech.vercel.app/"
  },
  {
    id: 4,
    title: "JUICE – Feel the Energy",
    category: "Software Development",
    description: "High-energy beverage website showcasing bold flavors, branding, modern UI experience",
    image: "project images/JUICE – Feel the Energy.jpeg",
    tags: ["Django", "Vue.js", "MySQL"],
    link: "https://juice-example-howztech.vercel.app/"
  },
  {
    id: 5,
    title: "Everest Steel – Strength Meets Style",
    category: "Mobile Development",
    description: "Premium steel almirah website highlighting durability, modern design, precision craftsmanship",
    image: "project images/Everest Steel – Strength Meets Style.jpeg",
    tags: ["Flutter", "Blockchain", "AWS"],
    link: "https://nes-example-howztech.vercel.app"
  },
  {
    id: 6,
    title: "Mirrors International – Where Craftsmanship Meets Artistry",
    category: "AI & Automation",
    description: "Luxury mirror website showcasing bespoke craftsmanship, premium materials, elegant aesthetics",
    image: "project images/Mirrors International – Where Craftsmanship Meets Artistry.jpeg",
    tags: ["React", "Python", "OpenAI"],
    link: "https://mirrors-example-howztech.vercel.app/"
  },
    {
    id: 7,
    title: "Lumière – Elegance Crafted in Every Gem",
    category: "",
    description: "Luxury jewelry website showcasing timeless elegance, handcrafted gems, premium experience",
    image: "project images/Lumière – Elegance Crafted in Every Gem.jpeg",
    tags: ["React", "Python", "OpenAI"],
    link: "https://lumiere-example-howztech.vercel.app/"
  },
    {
    id: 8,
    title: "Royal Arabic Perfumery Experience",
    category: "",
    description: "Luxury Arabic perfumery website with GCC-focused design, concierge checkout experience.",
    image: "project images/Royal Arabic Perfumery Experience.jpeg",
    tags: ["React", "Python", "OpenAI"],
    link: "https://perfumes-example-howztech.vercel.app/"
  },
    {
    id: 9,
    title: "Elite Auto Gallery – Phantom VIII Digital Showcase",
    category: "",
    description: "Luxury automotive showcase website with immersive visuals and user experience",
    image: "project images/Elite Auto Gallery – Phantom VIII Digital Showcase.jpeg",
    tags: ["React", "Python", "OpenAI"],
    link: "https://elite-example-howztech.vercel.app/"
  },
    {
    id: 10,
    title: "Obsidian Elite Motors – Exclusive Hypercar Experience",
    category: "",
    description: "Luxury hypercar dealership website with exclusive inventory, branding, seamless inquiries",
    image: "project images/Obsidian Elite Motors – Exclusive Hypercar Experience.jpeg",
    tags: ["React", "Python", "OpenAI"],
    link: "https://motors-example-howztech.vercel.app/"
  },
    {
    id: 11,
    title: "Elite Watches – Timeless Luxury Digital Experience",
    category: "",
    description: "Luxury watch ecommerce website emphasizing craftsmanship, exclusivity, visuals, seamless inquiries",
    image: "project images/Elite Watches – Timeless Luxury Digital Experience.jpeg",
    tags: ["React", "Python", "OpenAI"],
    link: "https://elite-watch-example-howztech.vercel.app/"
  },
  //   {
  //   id: 12,
  //   title: "",
  //   category: "",
  //   description: "",
  //   image: "",
  //   tags: ["React", "Python", "OpenAI"],
  //   link: ""
  // }
];




export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    position: "CEO, TechStart Inc.",
    company: "TechStart Inc.",
    content: "HowzTech transformed our digital presence completely. Their team's expertise in AI and modern web development is unmatched. We saw a 300% increase in user engagement.",
    rating: 5,
    avatar: "SJ"
  },
  {
    id: 2,
    name: "Michael Chen",
    position: "CTO, InnovateCorp",
    company: "InnovateCorp",
    content: "The ERP solution they built for us streamlined our entire operation. Their attention to detail and commitment to quality is exceptional. Highly recommended!",
    rating: 5,
    avatar: "MC"
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    position: "Product Manager, CloudSoft",
    company: "CloudSoft",
    content: "Working with HowzTech has been a game-changer. Their mobile app development expertise helped us launch ahead of schedule with a product our users love.",
    rating: 5,
    avatar: "ER"
  },
  {
    id: 4,
    name: "David Thompson",
    position: "Founder, AIVentures",
    company: "AIVentures",
    content: "HowzTech's AI automation solutions saved us countless hours. Their innovative approach and technical prowess are exactly what we needed.",
    rating: 5,
    avatar: "DT"
  }
];

export const blogPost = {
  id: 1,
  title: "The Future of AI in Enterprise Software Development",
  excerpt: "Discover how artificial intelligence is revolutionizing the way businesses build and deploy enterprise applications. Learn about the latest trends and best practices.",
  author: "HowzTech Team",
  date: "December 15, 2025",
  readTime: "8 min read",
  image: "https://images.unsplash.com/photo-1768224656445-33d078c250b7",
  category: "AI & Technology"
};

export const whyHowzTech = [
  {
    id: 1,
    title: "Cutting-Edge Technology",
    description: "We leverage the latest technologies and frameworks to deliver future-proof solutions."
  },
  {
    id: 2,
    title: "Expert Team",
    description: "Our team of seasoned developers, designers, and strategists bring years of experience."
  },
  {
    id: 3,
    title: "Client-Centric Approach",
    description: "Your success is our priority. We work closely with you at every step of the journey."
  },
  {
    id: 4,
    title: "Proven Track Record",
    // description: "50+ successful projects delivered to startups and enterprises worldwide."
    description: "50+ successful projects completed, helping clients worldwide."
  }
];
